(function () {
    "use strict";

    // @ngInject
    function NetworkLikesDirectiveControllerFunc(
            $scope, $injector, NetworkManager, AnalyticsService, _,
            moment, AppStates) {

        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'NetworkLikesDirectiveController';
        this.NetworkManager = NetworkManager;
        this.currUser = this.NetworkManager.getNetworkCurrUser();
        this.AnalyticsService = AnalyticsService;
        this._ = _;
        this.moment = moment;
        this.AppStates = AppStates;
        this.initializeLikes();
    }

    var NetworkLikesDirectiveController = Class(Controllers.BaseController, {
        constructor: NetworkLikesDirectiveControllerFunc,

        updateDoesCurrUserLikeProject: function updateDoesCurrUserLikeProject() {
            if (this.project.user_ids_who_liked_project.indexOf(this.currUser._id) !== -1) {
                this.doesCurrUserLikeProject = true;
            } else {
                this.doesCurrUserLikeProject = false;
            }
            this.projectLikeCount = this.project.user_ids_who_liked_project.length;
        },

        toggleLikeProject: function toggleLikeProject(event) {
            this.NetworkManager.setProjectLikeStatus(
                this.project, !this.doesCurrUserLikeProject).then(
                function success() {
                    this.updateDoesCurrUserLikeProject();
                }.bind(this));

            if (event) {
                event.stopPropagation();
                event.preventDefault();
            }
        },

        initializeLikes: function initializeLikes() {
            if (this.project.user_ids_who_liked_project) {
                this.updateDoesCurrUserLikeProject();
            } else {
                this.project.on('success', function () {
                    if (this.projectLikeCount === undefined) {
                        this.updateDoesCurrUserLikeProject();
                    }
                }.bind(this));
            }
        }
    });

    function NetworkLikesDirective() {
        return {
            scope: {
                project: "=",
                compact: "@"
            },
            templateUrl: 'angular/app/modules/network/features/likes/network_likes_directive_template.html',
            controller: 'NetworkLikesDirectiveController',
            controllerAs: 'networkLikesVm',
            bindToController: true
        };
    };

    angular.module('honeybook.network.features.likes', [])
        .controller('NetworkLikesDirectiveController', NetworkLikesDirectiveController)
        .directive('hbNetworkLikes', NetworkLikesDirective)

}());